"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAvatar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AvatarMixin = require("../../mixins/components/AvatarMixin");
var StyledAvatar = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledAvatar",
  componentId: "c11n-8-107-0__sc-1581h9e-0"
})(["", ""], _AvatarMixin.AvatarMixin);
exports.StyledAvatar = StyledAvatar;